





















































































import Vue from "vue";
import FormDialog, { iFormDialogOptions } from "@/components/FormDialog.vue";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "white-list",
  data() {
    return {
      campaigns: null,
      searchDebounce: null,
      search: "",
      selectedCampaign: "",
      selected: [],
      loadDone: false,
      blacklists: null,
      blacklistOptions: null,
      page: 1,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      total: 0
    };
  },
  components: {
    FormDialog
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
    this.reload();
  },
  methods: {
    ...mapActions({ checkShowMenu: "menu/checkShowMenu" }),
    async reload(local = true) {
      try {
        this.loadDone = false;
        let tasks: any[] = [];
        tasks.push(
          this.$store
            .dispatch("campaign/getList", { local: true, query: { limit: 0 } })
            .then(res => (this.campaigns = [...res]))
        );
        tasks.push(
          this.$store
            .dispatch("blacklist/getList", {
              local,
              query: {
                limit: this.perPage,
                filter: this.createFilter(),
                page: this.page
              }
            })
            .then(res => {
              this.blacklists = [...res.map((x, i) => ({ ...x, index: i }))];
            })
        );
        await Promise.all(tasks);
        this.total = this.$store.getters["blacklist/total"];
      } catch (err) {
        this.$store.dispatch(
          "error/handleError",
          err,
          "Lấy danh sách vòng quay thất bại"
        );
      } finally {
        this.loadDone = true;
      }
    },
    createFilter() {
      let filter = {};
      if (this.search) filter["phone"] = { $regex: `${this.search}` };
      if (this.selectedCampaign) filter["campaignCode"] = this.selectedCampaign;
      if (Object.keys(filter).length) return filter;
      return undefined;
    },
    createBlackList() {
      this.blacklistOptions = {
        title: "Tạo số danh sách đen",
        confirmText: "Tạo số danh sách đen",
        confirmFn: async data => {
          if (data) {
            try {
              this.loadDone = false;
              let result = await this.$store.dispatch("blacklist/add", data);
              this.$buefy.toast.open({
                message: "Thêm danh sách đen thành công",
                type: "is-success"
              });
              await this.reload(false);
            } catch (err) {
              this.$store.dispatch(
                "error/handleError",
                err,
                "Thêm vào danh sách đen thất bại"
              );
            }
          }
        },
        fields: [
          {
            label: "Số điện thoại",
            property: "phone",
            inputType: "phone",
            col: "is-4",
            required: true
          },
          {
            label: "Vòng quay",
            property: "campaignCode",
            col: "is-8",
            required: true,
            class: "",
            type: "select",
            placeholder: "Chọn vòng quay",
            options: this.campaigns.map(x => ({
              code: x.code,
              display: x.code + " - " + x.title
            })),
            current:
              this.campaigns && this.campaigns.length
                ? this.campaigns[this.campaigns.length - 1].code
                : null
          }
        ]
      };
    },
    async removeSelected() {
      if (!this.selected || !this.selected.length) return;
      this.$buefy.dialog.confirm({
        message: "Bạn có chắc chắn muốn xóa không?",
        onConfirm: async () => {
          try {
            this.loadDone = false;
            let tasks: any[] = [];
            for (let select of this.selected) {
              tasks.push(
                await this.$store.dispatch("blacklist/delete", select._id)
              );
            }
            await Promise.all(tasks);
            this.selected = [];
            this.$buefy.toast.open({
              message: "Xóa thành công",
              type: "is-success"
            });
            await this.reload(false);
          } catch (err) {
            this.$store.dispatch(
              "error/handleError",
              err,
              "Xóa danh sách đen thất bại"
            );
          }
        }
      });
    },
    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.filterChanged();
      }, 300);
    },
    filterChanged() {
      this.page = 1;
      this.reload();
    },
    onPageChange(page) {
      this.page = page;
      this.reload();
    }
  }
});
